module.exports = __webpack_public_path__ + "img/16.330994b3.jpg";